export enum RoleType {
  admin = "admin",
  user = "user",
  player = "player",
  creator = "creator"
}